<kbxl-color-bar></kbxl-color-bar>
<div class="progress-indicator" *ngIf="!pageReady">
  <div class="progressspinner-container">
    <p-progressSpinner></p-progressSpinner>
  </div>
</div>
<div class="page-container" *ngIf="pageReady">
  <div class="d-flex flex-column">
    <div class="p-1 position-relative">
      <kbxl-counter-offer-action-item-filter
        [loading]="loadingFilter$ | async"
        [actionItemStatuses]="actionItemStatuses$ | async"
        [states]="states$ | async"
        [isMobile]="isMobile$ | async"
        [companyUsers]="companyUsers$ | async"
        [user]="user"
        (search)="search($event)"
        (clear)="clear()"
      ></kbxl-counter-offer-action-item-filter>
    </div>
    <div class="grid-container px-1">
      <kbxl-counter-offer-action-item-grid
        [loading]="loading$ | async"
        [actionItemLoads]="actionItems$ | async"
        [user]="user"
        (selected)="selected($event)"
        (lazyLoad)="onLazyLoadEvent($event)"
        [lazy]="true"
        [totalRecords]="totalRecords$ | async"
        (reload)="refreshData($event)"
      ></kbxl-counter-offer-action-item-grid>
    </div>
  </div>
</div>
<router-outlet></router-outlet>
